import SeoMetadata from "../seo-metadata/seo-metadata";
import MainPageView from "../main-page";

export default function MainPage() {
  return (
    <>
      <SeoMetadata />
      <MainPageView />
    </>
  );
}
